/***
 *
 *   DASHBOARD
 *   Template dashboard example demonstrating various components inside a view.
 *
 **********/

import axios from "axios";
import { IconedButton } from "components/IconedButton";
import { FieldInput } from "components/fieldInput";
import { Animate, Icon, ViewContext } from "components/lib";
import { Formik } from "formik";
import { Fragment, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import coverwhaleData from "./data/Coverage.json";
import FMCSA from "./images/FMCSA.svg";
import SMS from "./images/SMS.svg";
import loading from "./images/loading.gif";
import styles from "./styles.module.scss";

export function Snapshot(props) {
  const [stage, setStage] = useState(0);
  const [DOTNumber, setDOTNumber] = useState("");
  const [data, setData] = useState();
  const [stateCoverWhale, setStateCoverWhale] = useState();
  const context = useContext(ViewContext);

  async function runAPI() {
    await axios
      .get("/api/snapshot?dot_number=" + DOTNumber)
      .then((r) => {
        setData(r.data);
        setStateCoverWhale(
          coverwhaleData[0].CoverWhale.filter((state) => {
            return state.State === r.data.generalData.phyState;
          })
        );
      })
      .catch((error) => {
        console.log(error);

        context.notification.show(
          "Failed on load snapshot data",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  useEffect(() => {
    if (stage === 1) {
      runAPI();
    }
  }, [stage]);

  const validationSchema = Yup.object().shape({
    dot_number: Yup.string().required("This field is required!"),
  });

  return (
    <Animate type="pop">
      {stage === 0 && (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "800px",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: "100px",
              borderRadius: "5px",
            }}
          >
            <Formik
              validationSchema={validationSchema}
              initialValues={{
                dot_number: "",
              }}
              onSubmit={(values) => {
                setStage(1);
                setDOTNumber(values.dot_number);
              }}
            >
              {({
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
                submitForm,
              }) => (
                <div
                  className={styles.form}
                  style={{
                    padding: "15px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <FieldInput
                    id="dot_number"
                    type="text"
                    label="DOT Number"
                    placeholder="Insert DOT Number"
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    showErrors
                    errors={errors.dot_number}
                    touched={touched.dot_number}
                  />
                  <div className={styles.footer}>
                    <button
                      className={styles.continue}
                      onClick={() => {
                        submitForm();
                      }}
                    >
                      Continue <Icon image="arrow-right" />
                    </button>
                  </div>
                </div>
              )}
            </Formik>
          </div>
        </div>
      )}

      {stage === 1 && (
        <Fragment>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <IconedButton
              size="130px"
              color="#d32425"
              textColor="white"
              icon="arrow-left"
              text="Go back"
              action={() => {
                setStage(0);
              }}
            />
          </div>
          {!data ? (
            <div
              className={styles.wrapper}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "calc(100vh - 155px)",
              }}
            >
              <img src={loading} alt="loading" width={23} height={23} />
            </div>
          ) : (
            <Fragment>
              {/* <div className={styles.wrapper}>
                <div className={styles.avatar}>
                  {data.generalData ? data.generalData.phyState : ""}
                </div>
                <div
                  className={styles.listCard}
                  style={{ marginLeft: "20px", height: "270px" }}
                >
                  <div className={styles.title}>Coverage</div>
                  <div className={styles.statelist}>
                    <div className={styles.list}>
                      <div className={styles.item}>
                        <span>Auto Liability</span>
                        {stateCoverWhale?.[0]?.["Auto Liability"] === "NO" ||
                        !stateCoverWhale?.[0]?.["Auto Liability"] ? (
                          <div className={styles.unchecked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                      <div className={styles.item}>
                        <span>Physical Damage</span>
                        {stateCoverWhale?.[0]?.["Physical Damage"] === "NO" ||
                        !stateCoverWhale?.[0]?.["Physical Damage"] ? (
                          <div className={styles.unchecked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                      <div className={styles.item}>
                        <span>Motor Truck Damage</span>
                        {stateCoverWhale?.[0]?.["Motor Truck Cargo"] === "NO" ||
                        !stateCoverWhale?.[0]?.["Motor Truck Cargo"] ? (
                          <div className={styles.unchecked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                      <div className={styles.item}>
                        <span>Trucker General Liability</span>
                        {stateCoverWhale?.[0]?.[
                          "Truckers General Liability"
                        ] === "NO" ||
                        !stateCoverWhale?.[0]?.[
                          "Truckers General Liability"
                        ] ? (
                          <div className={styles.unchecked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                      <div className={styles.item}>
                        <span>Non trucking Liability</span>
                        {stateCoverWhale?.[0]?.["Non Trucking Liability"] ===
                          "NO" ||
                        !stateCoverWhale?.[0]?.["Non Trucking Liability"] ? (
                          <div className={styles.unchecked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                      <div className={styles.item}>
                        <span>Hot Shots</span>
                        {stateCoverWhale?.[0]?.["Hot Shots"] === "NO" ||
                        !stateCoverWhale?.[0]?.["Hot Shots"] ? (
                          <div className={styles.unchecked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                      <div className={styles.item}>
                        <span>UIIA</span>
                        {stateCoverWhale?.[0]?.UIIA === "NO" ||
                        !stateCoverWhale?.[0]?.UIIA ? (
                          <div className={styles.checked}>
                            <Icon image="x" color="#fff" />
                          </div>
                        ) : (
                          <div className={styles.checked}>
                            <Icon image="check" color="#fff" />
                          </div>
                        )}
                      </div>
                    </div>
                    {/*     <div className={styles.list}>
                <span>Progressive:</span>
                <div className={styles.item}>
                  <span>Auto Liability</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>Physical Damage</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>Motor Truck Damage</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>Trucker General Liability</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>Non trucking Liability</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>Motor Truck Damage</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>Hot Shots</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
                <div className={styles.item}>
                  <span>UIIA</span>
                  <div className={styles.checked}>
                    <Icon image="check" color="#fff" />
                  </div>
                </div>
              </div> */}


             {/*   </div>
                </div>
              </div> */}


              {/* <div className={styles.wrapper}>
                <div className={styles.listCard} style={{ width: "100%" }}>
                  <div className={styles.title}>Cargo</div>
                  <div className={styles.statelist}>
                    <div className={styles.list}>
                      {data.cargo.map((value, index) => {
                        return (
                          <div
                            className={styles.item}
                            style={{ maxWidth: "130px" }}
                          >
                            <span>{value.cargoClassDesc}</span>
                            <div className={styles.checked}>
                              <Icon image="check" color="#fff" />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div> */}
              <div style={{ marginTop: 20 }}>
                <div className={styles.fullCard}>
                  <div className={styles.title}>Additional Company Details</div>
                  <div className={styles.contentWrapper}>
                    <div className={styles.content}>
                      <div className={styles.item}>
                        <span>Legal Name:</span>&nbsp;
                        {data.generalData.legalName}
                      </div>
                      <div className={styles.item}>
                        <span>DBA Name:</span>&nbsp;
                        {data.generalData.dbaName || "Not found"}
                      </div>
                      <div className={styles.item}>
                        <span>Address:</span>&nbsp;
                        {data.generalData.phyCity +
                          ", " +
                          data.generalData.phyState || "Address not found"}
                      </div>
                      <div className={styles.item}>
                        <span>Phone:</span>&nbsp;
                        {data.generalData.telephone || "Not found"}
                      </div>
                      <div className={styles.item}>
                        <span>Email:</span>&nbsp;
                        {data.generalData.emailAddress || "Not found"}
                      </div>
                    </div>
                    <div className={styles.content}>
                      <div className={styles.item}>
                        <span>Fleet Size:</span>&nbsp;
                        {data.generalData.totalPowerUnits}
                      </div>
                      <div className={styles.item}>
                        <span>Number of Drivers:</span>&nbsp;
                        {data.generalData.totalDrivers}
                      </div>
                      <div className={styles.item}>
                        <span>Current Carrier:</span>&nbsp;Progressive
                      </div>
                      <div className={styles.item}>
                        <span>Renewal Date:</span>&nbsp;08/01/2023
                      </div>
                      <div className={styles.item}>
                        <span>Operating Status:</span>&nbsp;
                        {data.operation.operationClassDesc}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 20 }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      backgroundColor: "white",
                      padding: 20,
                      marginRight: 10,
                    }}
                  >
                    <img
                      src={FMCSA}
                      alt="fmcsa"
                      style={{ marginBottom: 20, marginTop: 10, height: 70 }}
                    />
                    <span>
                      View the company snapshot on the FMCSA site for insight
                      into a motor carrier’s business operations, filing status,
                      insurance history, and much more.
                    </span>
                    <div
                      style={{
                        backgroundColor: "#BA1F21",
                        width: "fit-content",
                        color: "white",
                        fontWeight: 600,
                        padding: 12,
                        borderRadius: 8,
                        marginTop: 20,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        window.open(
                          `https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=USDOT&query_string=${DOTNumber}`
                        );
                      }}
                    >
                      Visit this Company on FMCSA
                    </div>
                  </div>
                  <div
                    style={{
                      width: "50%",
                      backgroundColor: "white",
                      padding: 20,
                      marginLeft: 10,
                    }}
                  >
                    <img
                      src={SMS}
                      alt="sms"
                      style={{ marginBottom: 20, marginTop: 10, height: 70 }}
                    />
                    <span>
                      SMS is the one stop shop for public motor carrier safety
                      data. Information from SMS can be used to help analyze a
                      motor carrier’s safety ratings to better understand your
                      quality of business.
                    </span>
                    <div
                      onClick={() => {
                        window.open(
                          `https://ai.fmcsa.dot.gov/SMS/Carrier/${DOTNumber}/Overview.aspx`
                        );
                      }}
                      style={{
                        backgroundColor: "#BA1F21",
                        width: "fit-content",
                        color: "white",
                        fontWeight: 600,
                        padding: 12,
                        borderRadius: 8,
                        marginTop: 20,
                        cursor: "pointer",
                      }}
                    >
                      Visit this Company on SMS
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </Fragment>
      )}
    </Animate>
  );
}
